module.exports = __webpack_public_path__ + "img/func-detail-2.c9b5655b.png";